import { HStack, Select, IconButton, Text, Box } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';
import { addDays, formatDateLabel } from '../utils';

interface VenueDateBarProps {
  locations: { id: string; name: string }[];
  locationId: string;
  onLocationChange: (id: string) => void;
  date: string;
  onDateChange: (date: string) => void;
  canGoBack: boolean;
  canGoForward: boolean;
}

export function VenueDateBar({
  locations,
  locationId,
  onLocationChange,
  date,
  onDateChange,
  canGoBack,
  canGoForward,
}: VenueDateBarProps) {
  const { t } = useTranslation();
  return (
    <HStack mb={5} spacing={3} wrap="wrap">
      <Select
        maxW="260px"
        value={locationId}
        onChange={(e) => onLocationChange(e.target.value)}
        bg="white"
      >
        {locations.map((l) => (
          <option key={l.id} value={l.id}>
            {l.name}
          </option>
        ))}
      </Select>
      <HStack spacing={1}>
        <IconButton
          aria-label={t('schedule.prevDay')}
          icon={<ChevronLeftIcon />}
          variant="outline"
          size="sm"
          isDisabled={!canGoBack}
          onClick={() => onDateChange(addDays(date, -1))}
        />
        <Box minW="140px" textAlign="center">
          <Text fontWeight="600" color="gray.700">
            {formatDateLabel(date)}
          </Text>
        </Box>
        <IconButton
          aria-label={t('schedule.nextDay')}
          icon={<ChevronRightIcon />}
          variant="outline"
          size="sm"
          isDisabled={!canGoForward}
          onClick={() => onDateChange(addDays(date, 1))}
        />
      </HStack>
    </HStack>
  );
}

export default VenueDateBar;
